// src/components/Labs/biology/components/BioDropZone.jsx
import React from "react";
import { useDrop } from "react-dnd";
import { motion } from "framer-motion";
import { ItemTypes } from "../../../../utils/constants";

export default function BioDropZone({ label, onDrop }) {
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: ItemTypes.SPECIMEN,
      drop: (item) => {
        if (item && item.id && onDrop) onDrop(item);
        return {};
      },
      collect: (monitor) => ({
        isOver: monitor.isOver(),
      }),
    }),
    [onDrop]
  );

  return (
    <motion.div
      ref={drop}
      initial={{ scale: 1 }}
      animate={{ scale: isOver ? 1.03 : 1 }}
      className={[
        "flex flex-col items-center justify-center",
        "w-64 sm:w-72 h-16 sm:h-18",
        "border-2 border-dashed rounded-xl bg-white/70",
        "transition-all duration-200",
        isOver ? "border-pink-400 bg-pink-50" : "border-pink-200",
      ].join(" ")}
    >
      <div className="text-xs sm:text-sm text-gray-600 text-center px-3">
        {label}
      </div>
    </motion.div>
  );
}
